import { render, staticRenderFns } from "./ScrollTopArrow.vue?vue&type=template&id=a94b708a&"
import script from "./ScrollTopArrow.vue?vue&type=script&lang=js&"
export * from "./ScrollTopArrow.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTopArrow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports